import { MenuItem } from '@material-ui/core'

// Return year items dropdown
const currentYear = new Date().getFullYear()
export const createYearItems = () => {
  let years = []
  let i = 1
  for (let y = currentYear; y >= 2019; y--) {
    years.push({ id: i++, year: y })
  }
  return years.map((el) => (
    <MenuItem key={el.id} value={el.year}>
      {el.year}
    </MenuItem>
  ))
}

// PI-344, The YEl contribution which ASPA is allowing now is just 2 option in the beginning
export const DISABLE_LAST_TWO_YEL_OPTIONS = true